<template>
  <div class="eventDetail" v-if="event">
    <h1>{{ event.title }}</h1>
    <span class="date"
      >{{ event.time }} on {{ event.date }} @ {{ event.location }}</span
    >
    <p>{{ event.description }}</p>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";

export default {
  name: "EventDetails",
  props: ["id"],
  data() {
    return {
      event: null,
    };
  },
  created() {
    //   Get Event Data from API
    EventService.getEvent(this.id)
      .then((response) => {
        this.event = response.data;
        console.log(this.event);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>